interface IconProps {
  color: string;
}

export const LocationFilledIcon = ({ color }: IconProps) => (
  <svg viewBox="316.12 372.68 177.75 266.87">
    <g>
      <path
        fill={color}
        d="M404.996 372.676c-49.09 0-88.879 39.793-88.879 88.879 0 16.664 4.582 32.246 12.559 45.574l76.316 132.191 76.38-132.285c7.937-13.305 12.5-28.86 12.5-45.476.003-49.09-39.786-88.883-88.876-88.883m0 118.625c-16.426 0-29.742-13.32-29.738-29.746 0-16.422 13.316-29.743 29.738-29.743 16.43 0 29.746 13.317 29.746 29.743 0 16.43-13.316 29.746-29.746 29.746m0 0"
      ></path>
    </g>
  </svg>
);
